import { Injectable } from "@angular/core";
import { SERVER_API_URL } from "src/app/app.constants";
import { IClientDTO } from "../model/client.model";
import { Observable } from "rxjs";
import { HttpResponse, HttpClient } from "@angular/common/http";
import { PartyToBeInsured } from "../model/certificate-trade-details.model";
type EntityResponseType = HttpResponse<IClientDTO>;


@Injectable({ providedIn: 'root' })
export class SpotClientService {
    private spotClientResourceUrl = SERVER_API_URL + 'api/users/spot-client';
    private resourceUrl = SERVER_API_URL + 'api/users/client';

    private partyToInsuredUrl = SERVER_API_URL + 'api/spot-client/party-to-insured/save';

    private getPartyToInsuredUrl = SERVER_API_URL + 'api/spot-client/get-party-to-insured';

    constructor(private http: HttpClient) {}

    createSpotClient(internalStaff: IClientDTO): Observable<EntityResponseType> {
        // const copy = this.convertDateFromClient(internalStaff);
        return this.http
            .post<IClientDTO>(this.spotClientResourceUrl, internalStaff, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }


    private convertDateFromServer(res: EntityResponseType): EntityResponseType {
        // res.body.effectiveFromDate = res.body.effectiveFromDate != null ? moment(res.body.effectiveFromDate) : null;
        // res.body.effectiveEndDate = res.body.effectiveEndDate != null ? moment(res.body.effectiveEndDate) : null;
        return res;
    }
    spotClientUpdate(internalStaff: IClientDTO): Observable<EntityResponseType> {
        // const copy = this.convertDateFromClient(internalStaff);
        return this.http
            .put<IClientDTO>(this.spotClientResourceUrl, internalStaff, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    spotCLientview(id: number): Observable<EntityResponseType> {
        return this.http
            .get<IClientDTO>(`${this.spotClientResourceUrl}/view/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http
            .get<IClientDTO>(`${this.resourceUrl}/${id}`, { observe: 'response' })
            .map((res: EntityResponseType) => this.convertDateFromServer(res));
    }

    savePartyToBeInusred(dto){
        return  this.http.post<any>(this.partyToInsuredUrl, dto,{ observe: 'response' });
    }

    getClientAsPartyToBeInsured(id){
        return this.http
            .get<PartyToBeInsured>(`${this.getPartyToInsuredUrl}/${id}`, { observe: 'response' })
            .map((res: HttpResponse<any>) => res);
    }

    generateOTP(url, dto){
        return this.http.post<any>(this.spotClientResourceUrl+url ,dto ,{ observe: 'response' });
    }

   
}